import * as React from 'react';
import { styled, alpha } from '@mui/material/styles';
import Button from '@mui/material/Button';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import EditIcon from '@mui/icons-material/Edit';
import Divider from '@mui/material/Divider';
import ArchiveIcon from '@mui/icons-material/Archive';
import FileCopyIcon from '@mui/icons-material/FileCopy';
import MoreHorizIcon from '@mui/icons-material/MoreHoriz';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';

import BodyText from './BodyText';
import {
	Box,
	Container,
	Grid,
	makeStyles,
	Avatar,
	Chip,
	Radio,
	RadioGroup,
	FormControlLabel,
	FormControl,
} from '@material-ui/core';
const useStyles = makeStyles((theme) => ({
	root: {
		'& .css-zddlty-MuiButtonBase-root-MuiButton-root': {
			padding: '19px 22px',
			background: 'white',
			color: 'black',
			border: '1px solid',
		},
		'& .css-zddlty-MuiButtonBase-root-MuiButton-root:hover': {
			background: 'white',
			border: '1px solid',
		},
	},
}));

const StyledMenu = styled((props) => (
	<Menu
		elevation={0}
		anchorOrigin={{
			vertical: 'bottom',
			horizontal: 'right',
		}}
		transformOrigin={{
			vertical: 'top',
			horizontal: 'right',
		}}
		{...props}
	/>
))(({ theme }) => ({
	'& .MuiPaper-root': {
		borderRadius: 6,
		marginTop: theme.spacing(1),
		minWidth: 330,
		color:
			theme.palette.mode === 'light'
				? 'rgb(55, 65, 81)'
				: theme.palette.grey[300],
		boxShadow:
			'rgb(255, 255, 255) 0px 0px 0px 0px, rgba(0, 0, 0, 0.05) 0px 0px 0px 1px, rgba(0, 0, 0, 0.1) 0px 10px 15px -3px, rgba(0, 0, 0, 0.05) 0px 4px 6px -2px',
		'& .MuiMenu-list': {
			padding: '4px 0',
		},
		'& .MuiMenuItem-root': {
			'& .MuiSvgIcon-root': {
				fontSize: 18,
				color: theme.palette.text.secondary,
				marginRight: theme.spacing(1.5),
			},
			'&:active': {
				backgroundColor: 'white',
			},
		},
	},
}));

export default function P() {
	const [anchorEl, setAnchorEl] = React.useState(null);
	const open = Boolean(anchorEl);
	const classes = useStyles();
	const [value, setValue] = React.useState('Economy');
	const handleRadio = (event) => {
		setValue(event.target.value);
	};
	const handleClick = (event) => {
		setAnchorEl(event.currentTarget);
	};
	const handleClose = () => {
		setAnchorEl(null);
	};
	const [adult, setAdult] = React.useState(0);
	return (
		<div className={classes.root}>
			<Button
				id='demo-customized-button'
				aria-controls={open ? 'demo-customized-menu' : undefined}
				aria-haspopup='true'
				aria-expanded={open ? 'true' : undefined}
				variant='contained'
				disableElevation
				onClick={handleClick}
				endIcon={<ExpandMoreIcon />}>
				<BodyText one>
					1 Traveller(s)<span>|</span>Economy
				</BodyText>
			</Button>
			<StyledMenu
				id='demo-customized-menu'
				MenuListProps={{
					'aria-labelledby': 'demo-customized-button',
				}}
				anchorEl={anchorEl}
				open={open}
				onClose={handleClose}>
				<MenuItem
					// onClick={handleClose}
					disableRipple
					style={{ justifyContent: 'space-between' }}>
					<BodyText>Adult</BodyText>
					<Box display='flex'>
						<Box
							style={{
								display: 'block',
								float: 'left',
								width: '40px',
								height: '40px',
								lineHeight: '40px',
								background: 'white',
								textAlign: 'center',
								borderRadius: 0,
								padding: 0,
								border: 0,
								cursor: 'pointer',

								boxShadow: '0 2px 10px rgb(0 0 0 / 15%)',
							}}
							onClick={() => (adult === 0 ? '' : setAdult(adult - 1))}>
							<BodyText
								textStyle={{
									marginTop: 8,
									color: adult === 0 ? 'wheat' : '',
								}}>
								-
							</BodyText>
						</Box>
						<Box
							style={{
								display: 'block',
								float: 'left',
								width: '40px',
								height: '40px',
								lineHeight: '40px',
								background: 'white',
								textAlign: 'center',
								borderRadius: 0,
								padding: 0,
								border: 0,
								boxShadow: '0 2px 10px rgb(0 0 0 / 15%)',
							}}>
							<BodyText textStyle={{ marginTop: 8 }}>{adult}</BodyText>
						</Box>
						<Box
							style={{
								display: 'block',
								float: 'left',
								width: '40px',
								height: '40px',
								lineHeight: '40px',
								background: 'white',
								textAlign: 'center',
								borderRadius: 0,
								padding: 0,
								cursor: 'pointer',

								border: 0,
								boxShadow: '0 2px 10px rgb(0 0 0 / 15%)',
							}}
							onClick={() => (adult === 9 ? '' : setAdult(adult + 1))}>
							<BodyText
								textStyle={{
									marginTop: 8,
									color: adult === 9 ? 'wheat' : '',
								}}>
								+
							</BodyText>
						</Box>
					</Box>
					{/* </Box> */}
				</MenuItem>
				<MenuItem
					// onClick={handleClose}
					disableRipple
					style={{ justifyContent: 'space-between' }}>
					<BodyText>Child</BodyText>
					<Box display='flex'>
						<Box
							style={{
								display: 'block',
								float: 'left',
								width: '40px',
								height: '40px',
								lineHeight: '40px',
								background: 'white',
								textAlign: 'center',
								borderRadius: 0,
								padding: 0,
								border: 0,
								cursor: 'pointer',

								boxShadow: '0 2px 10px rgb(0 0 0 / 15%)',
							}}
							onClick={() => (adult === 0 ? '' : setAdult(adult - 1))}>
							<BodyText
								textStyle={{
									marginTop: 8,
									color: adult === 0 ? 'wheat' : '',
								}}>
								-
							</BodyText>
						</Box>
						<Box
							style={{
								display: 'block',
								float: 'left',
								width: '40px',
								height: '40px',
								lineHeight: '40px',
								background: 'white',
								textAlign: 'center',
								borderRadius: 0,
								padding: 0,
								border: 0,
								boxShadow: '0 2px 10px rgb(0 0 0 / 15%)',
							}}>
							<BodyText textStyle={{ marginTop: 8 }}>{adult}</BodyText>
						</Box>
						<Box
							style={{
								display: 'block',
								float: 'left',
								width: '40px',
								height: '40px',
								lineHeight: '40px',
								background: 'white',
								textAlign: 'center',
								borderRadius: 0,
								padding: 0,
								cursor: 'pointer',

								border: 0,
								boxShadow: '0 2px 10px rgb(0 0 0 / 15%)',
							}}
							onClick={() => (adult === 9 ? '' : setAdult(adult + 1))}>
							<BodyText
								textStyle={{
									marginTop: 8,
									color: adult === 9 ? 'wheat' : '',
								}}>
								+
							</BodyText>
						</Box>
					</Box>
					{/* </Box> */}
				</MenuItem>
				<MenuItem
					// onClick={handleClose}
					disableRipple
					style={{ justifyContent: 'space-between' }}>
					<BodyText>Infant</BodyText>
					<Box display='flex'>
						<Box
							style={{
								display: 'block',
								float: 'left',
								width: '40px',
								height: '40px',
								lineHeight: '40px',
								background: 'white',
								textAlign: 'center',
								borderRadius: 0,
								padding: 0,
								border: 0,
								cursor: 'pointer',

								boxShadow: '0 2px 10px rgb(0 0 0 / 15%)',
							}}
							onClick={() => (adult === 0 ? '' : setAdult(adult - 1))}>
							<BodyText
								textStyle={{
									marginTop: 8,
									color: adult === 0 ? 'wheat' : '',
								}}>
								-
							</BodyText>
						</Box>
						<Box
							style={{
								display: 'block',
								float: 'left',
								width: '40px',
								height: '40px',
								lineHeight: '40px',
								background: 'white',
								textAlign: 'center',
								borderRadius: 0,
								padding: 0,
								border: 0,
								boxShadow: '0 2px 10px rgb(0 0 0 / 15%)',
							}}>
							<BodyText textStyle={{ marginTop: 8 }}>{adult}</BodyText>
						</Box>
						<Box
							style={{
								display: 'block',
								float: 'left',
								width: '40px',
								height: '40px',
								lineHeight: '40px',
								background: 'white',
								textAlign: 'center',
								borderRadius: 0,
								padding: 0,
								cursor: 'pointer',

								border: 0,
								boxShadow: '0 2px 10px rgb(0 0 0 / 15%)',
							}}
							onClick={() => (adult === 9 ? '' : setAdult(adult + 1))}>
							<BodyText
								textStyle={{
									marginTop: 8,
									color: adult === 9 ? 'wheat' : '',
								}}>
								+
							</BodyText>
						</Box>
					</Box>
					{/* </Box> */}
				</MenuItem>
				<MenuItem
					style={{ justifyContent: 'space-between' }}
					alignItems='self-end'>
					<Box>
						<FormControl component='fieldset'>
							{/* <FormLabel component='legend'>Gender</FormLabel> */}
							<RadioGroup
								aria-label='gender'
								name='gender1'
								value={value}
								onChange={handleRadio}>
								<FormControlLabel
									value='Economy'
									control={<Radio />}
									label='Economy'
								/>
								<FormControlLabel
									value='Business'
									control={<Radio />}
									label='Business'
								/>
								<FormControlLabel
									value='First Class'
									control={<Radio />}
									label='First Class'
								/>
								<FormControlLabel
									value='Premium Economy'
									control={<Radio />}
									label='Premium Economy'
								/>
							</RadioGroup>
						</FormControl>
					</Box>
					<Box
						style={{
							padding: 10,
							backgroundColor: '#39c9bb',
							cursor: 'pointer',
						}}>
						<BodyText textStyle={{ color: 'white' }}>Done</BodyText>
					</Box>
				</MenuItem>
			</StyledMenu>
		</div>
	);
}
